import { container } from 'libs/growth-platform-brand-system-v2/src/styles/themes';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React, { Fragment, lazy, useMemo, useRef } from 'react';
import { Subpath, linkResolver } from '../../utils/linkResolver';
import { BlogStickyBannerComponent } from '../BlockComponents/BlogStickyBannerComponent';
import { BlocksTypeArticle } from './BlocksTypeArticle';
import { getTableOfContentHeading } from './logic';

const MediaShareLinksComponent = lazy(
  () => import('../BlockComponents/MediaShareLinksComponent'),
);

const BlockTableOfContentFullComponent = lazy(
  () => import('../BlockComponents/BlockTableOfContentFullComponent'),
);

const AuthorComponent = lazy(
  () => import('../BlockComponents/AuthorComponent'),
);

export const TemplateArticleZone = ({
  doc,
  locale,
  isNewFeature = false,
}: any) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const headingElementsRef = useRef<HTMLElement[]>([]);
  const author = doc.hero[0]?.author;
  const stickyBanner = doc.stickyBanner?.find(
    (el: any) => el.__typename === 'DatoCmsBlogBannerBlock',
  )?.banner?.banner?.[0];
  const headings = useMemo(() => getTableOfContentHeading(doc), [doc]);

  return (
    <>
      {stickyBanner && (
        <BlogStickyBannerComponent
          stickyBanner={stickyBanner}
          forceTitleResponsive
          key={stickyBanner.id}
          locale={locale}
          className={classNames(
            'block lg:hidden',
            'fixed sm:fixed',
            'z-30',
            'left-0 bottom-0 sm:bottom-0 lg:top-88',
          )}
        />
      )}
      <div
        className={classNames(
          'TemplateArticleZone',
          'lg:grid lg:grid-cols-12 lg:gap-24',
          'py-16 lg:py-24 lg:pb-64 sm:text-[18px] md:text-[20px]',
          container,
        )}
      >
        <section className="lg:col-span-8 lg:mr-24 lg:col-start-1">
          {doc.blocks.map(({ anchor, ...block }: any, index: any) => {
            return (
              <div id={anchor} key={index}>
                <BlocksTypeArticle
                  {...{
                    block,
                    locale,
                    index,
                    headingElementsRef,
                    sidebarRef,
                    headings,
                  }}
                />
              </div>
            );
          })}

          {isNewFeature && (
            <>
              <hr className="border-t border-neutral-101 opacity-50" />
              <div className="pt-40 flex justify-between">
                {author && (
                  <AuthorComponent
                    author={author}
                    locale={locale}
                    date={doc.date}
                  />
                )}
              </div>
            </>
          )}
        </section>

        {/* Sidebar */}
        <div
          className={classNames(
            'lg:col-span-4 lg:col-start-9 py-40',
            'hidden lg:block',
          )}
        >
          <div
            ref={sidebarRef}
            className={classNames(
              'flex flex-col md:sticky lg:sticky',
              'gap-40 md:top-72 lg:top-88',
            )}
          >
            <MediaShareLinksComponent
              url={`https://payfit.com${linkResolver(
                doc,
                locale,
                '',
                Subpath.BlogArticles,
              )}`}
              locale={locale}
            />
            {doc.blocks.map((block: any, i: any) => {
              if (block.__typename === 'DatoCmsTableOfContent') {
                return (
                  <BlockTableOfContentFullComponent
                    key={i}
                    locale={locale}
                    headings={headings}
                    block={block}
                    headingElementsRef={headingElementsRef}
                    sidebarRef={sidebarRef}
                  />
                );
              }
              return <Fragment key={i} />;
            })}

            {stickyBanner && (
              <BlogStickyBannerComponent
                key={stickyBanner?.id}
                stickyBanner={stickyBanner}
                locale={locale}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
